import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  GET_WALLET_STATEMENT_REQUEST,
  GET_WALLET_STATEMENT_SUCCESS,
  GET_WALLET_STATEMENT_FAILURE,
} from "../../redux/constants/walletConstant";

export const getStatementAction = (userId) => async (dispatch) => {
  try {
    dispatch({ type: GET_WALLET_STATEMENT_REQUEST });
    const URL = `${ApiUrl.getWalletStateByUserId}?userId=${userId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_WALLET_STATEMENT_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_WALLET_STATEMENT_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_WALLET_STATEMENT_FAILURE,
        payload: error.response.data,
      });
    }
  }
};
